<template>
  <div class="repair-page">
    <div class="repair-card">
      <div class="repair-header">
        <div class="repair-title">绑定报修师傅</div>
        <div class="repair-divider"></div>
        <div class="repair-toolbar">
          <div class="repair-actions">
            <el-button size="small" class="repair-btn-back" @click="_goBack">返回</el-button>
            <el-button size="small" class="repair-btn-add" @click="_openAddRepairTypeUserModal"><i class="el-icon-plus"></i>添加</el-button>
            <el-button size="small" class="repair-btn-refresh" title="刷新" @click="_listRepairTypeUsers(currentPage, pageSize)"><i class="el-icon-refresh-right"></i></el-button>
          </div>
          <div class="repair-search-group">
            <el-input v-model="keyword" size="small" clearable placeholder="请输入" class="repair-search-input" @keyup.enter.native="handleSearch" />
            <el-button size="small" class="repair-btn-search" @click="handleSearch"><i class="el-icon-search"></i>搜索</el-button>
          </div>
        </div>
      </div>

      <div class="repair-table-section">
        <el-table v-loading="loading" :data="filteredRepairTypeUsers" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.communityName || '-' }}</template></el-table-column>
          <el-table-column prop="staffId" label="维修师傅ID" min-width="150" show-overflow-tooltip />
          <el-table-column prop="staffName" label="师傅名称" min-width="130" show-overflow-tooltip />
          <el-table-column prop="repairTypeName" label="报修类型" min-width="130" show-overflow-tooltip />
          <el-table-column prop="stateName" label="状态" min-width="100"><template slot-scope="scope"><span :class="['status-tag', scope.row.state === '9999' ? 'status-done' : 'status-other']">{{ scope.row.stateName || '-' }}</span></template></el-table-column>
          <el-table-column prop="remark" label="说明" min-width="160" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="170" show-overflow-tooltip />
          <el-table-column label="操作" min-width="150" fixed="right">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link danger" @click="_openDeleteTypeUserModel(scope.row)">删除</a>
                <span class="link-separator"></span>
                <a class="action-link" @click="_openEditrepairTypeUserModel(scope.row)">变更报修师傅</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="repair-pagination">
        <span class="pagination-total">共{{ repairTypeUserManageInfo.total }}条</span>
        <el-pagination :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="repairTypeUserManageInfo.total" @current-change="handleCurrentChange" />
        <el-select v-model="pageSize" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <add-repair-type-user ref="addRepairTypeUser" @selectStaffs="handleSelectStaffs" />
    <delete-repair-type-user ref="deleteRepairTypeUser" @success="handleDeleteSuccess" />
    <edit-repair-type-user ref="editRepairTypeUser" @success="handleEditSuccess" />
  </div>
</template>

<script>
import { listRepairTypeUsers, saveRepairTypeUser } from '@/api/work/repairTypeUserApi'
import { getCommunityId } from '@/api/community/communityApi'
import AddRepairTypeUser from '@/components/work/AddRepairTypeUser'
import DeleteRepairTypeUser from '@/components/work/DeleteRepairTypeUser'
import EditRepairTypeUser from '@/components/work/EditRepairTypeUser'

export default {
  name: 'RepairTypeUserList',
  components: { AddRepairTypeUser, DeleteRepairTypeUser, EditRepairTypeUser },
  data() {
    return {
      loading: false,
      keyword: '',
      repairTypeUserManageInfo: { repairTypeUsers: [], total: 0, repairType: '', communityId: '' },
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    filteredRepairTypeUsers() {
      if (!this.keyword) return this.repairTypeUserManageInfo.repairTypeUsers
      return this.repairTypeUserManageInfo.repairTypeUsers.filter(item => [item.staffId, item.staffName, item.repairTypeName, item.remark].some(value => String(value || '').includes(this.keyword)))
    }
  },
  created() {
    this.repairTypeUserManageInfo.repairType = this.$route.query.repairType
    this.repairTypeUserManageInfo.communityId = this.$route.query.communityId || getCommunityId()
    this._listRepairTypeUsers(this.currentPage, this.pageSize)
  },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 500, height: '44px', padding: '0', border: 'none' } },
    cellStyle() { return { color: '#1D2129', height: '48px', padding: '0', border: 'none' } },
    async _listRepairTypeUsers(page, size) {
      this.loading = true
      try {
        const response = await listRepairTypeUsers({ page, row: size, communityId: this.repairTypeUserManageInfo.communityId, repairType: this.repairTypeUserManageInfo.repairType })
        if (response.code === 0) {
          this.repairTypeUserManageInfo.repairTypeUsers = response.data || []
          this.repairTypeUserManageInfo.total = Number(response.total || response.records || 0)
        } else {
          this.$message.error(response.msg || '获取报修师傅失败')
        }
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.currentPage = 1; this._listRepairTypeUsers(1, this.pageSize) },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this._listRepairTypeUsers(1, val) },
    handleCurrentChange(val) { this.currentPage = val; this._listRepairTypeUsers(val, this.pageSize) },
    async _openAddRepairTypeUserModal() {
      try {
        const response = await listRepairTypeUsers({
          page: 1,
          row: 1000,
          communityId: this.repairTypeUserManageInfo.communityId,
          repairType: this.repairTypeUserManageInfo.repairType
        })
        this.$refs.addRepairTypeUser.open(response.data || [], this.repairTypeUserManageInfo.communityId)
      } catch (error) {
        this.$message.error(error.message || '获取报修师傅失败')
      }
    },
    async _openEditrepairTypeUserModel(row) {
      try {
        const response = await listRepairTypeUsers({
          page: 1,
          row: 1000,
          communityId: this.repairTypeUserManageInfo.communityId,
          repairType: this.repairTypeUserManageInfo.repairType
        })
        this.$refs.editRepairTypeUser.open(row, response.data || [])
      } catch (error) {
        this.$message.error(error.message || '获取报修师傅失败')
      }
    },
    _openDeleteTypeUserModel(row) { this.$refs.deleteRepairTypeUser.open(row) },
    _goBack() { this.$router.go(-1) },
    async handleSelectStaffs(staffs) {
      try {
        for (const staff of staffs) {
          const response = await saveRepairTypeUser({
            communityId: this.repairTypeUserManageInfo.communityId,
            staffId: staff.staffId,
            staffName: staff.staffName,
            repairType: this.repairTypeUserManageInfo.repairType
          })
          if (response.code !== 0) {
            throw new Error(response.msg || '保存失败')
          }
        }
        this.$message.success('操作成功')
        this._listRepairTypeUsers(this.currentPage, this.pageSize)
      } catch (error) {
        this.$message.error(error.message || '保存失败')
      }
    },
    handleDeleteSuccess() { this._listRepairTypeUsers(this.currentPage, this.pageSize) },
    handleEditSuccess() { this._listRepairTypeUsers(this.currentPage, this.pageSize) }
  }
}
</script>

<style scoped>
.repair-page { height: 100%; background: #F5F8FC; }
.repair-card { min-height: 100%; background: #FFFFFF; border-radius: 0 0 12px 12px; display: flex; flex-direction: column; overflow: hidden; }
.repair-header { padding: 20px 24px 12px; flex-shrink: 0; }
.repair-title { font: 600 16px/22px 'PingFang SC', sans-serif; color: #1D2129; }
.repair-divider { height: 1px; background: #DCE6F5; margin: 12px 0; }
.repair-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.repair-actions, .repair-search-group, .action-links, .repair-pagination { display: flex; align-items: center; }
.repair-actions { gap: 12px; }
.repair-search-group { gap: 12px; margin-left: auto; }
.repair-btn-add { height: 38px; padding: 0 16px; background: #0E76FF; border: none; border-radius: 10px; color: #fff; font-size: 14px; }
.repair-btn-back, .repair-btn-refresh { height: 38px; padding: 0 16px; border-radius: 10px; border: 1px solid #DCE6F5; color: #364153; background: #fff; }
.repair-btn-refresh { width: 38px; padding: 0; }
.repair-btn-search { height: 38px; padding: 0 16px; border-radius: 10px; border: 1px solid #0E76FF; background: #fff; color: #0E76FF; }
.repair-search-input { width: 180px; }
.repair-search-group >>> .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; color: #1D2129; }
.repair-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.repair-table-section >>> .el-table { border-radius: 8px; overflow: hidden; }
.repair-table-section >>> .el-table::before { display: none; }
.repair-table-section >>> .el-table th, .repair-table-section >>> .el-table td { border: none; }
.action-links { gap: 8px; white-space: nowrap; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; }
.action-link.danger { color: #F53F3F; }
.link-separator { width: 1px; height: 12px; background: #DCE6F5; }
.status-tag { display: inline-flex; align-items: center; justify-content: center; min-width: 58px; height: 24px; padding: 0 8px; border-radius: 6px; font-size: 13px; }
.status-done { background: #E8F7EF; color: #0E8A45; }
.status-other { background: #E8F3FF; color: #0E76FF; }
.repair-pagination { justify-content: flex-end; gap: 8px; padding: 16px 24px 24px; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.pagination-size-select { width: 96px; }
.pagination-size-select >>> .el-input__inner { height: 32px; border-radius: 8px; }
</style>
